<ca-modal-container
    modalTitle="{{ 'MODULES.DETAIL.SHARING.TITLE' | translate }}"
    description="{{ 'MODULES.DETAIL.SHARING.SUBTITLE' | translate }}"
    (dismiss)="dismiss('Canceled')"
>
    <form (submit)="save()">
        <div class="input-group w-100">
            <input
                #searchUsersInput
                type="text"
                name="userToAdd"
                class="form-control"
                [(ngModel)]="userToAdd"
                [ngbTypeahead]="searchUsers$"
                [popupClass]="'custom-typeahead'"
                (selectItem)="selectUser($event)"
                [resultFormatter]="formatUserWithEmail"
                [inputFormatter]="formatUser"
                [resultTemplate]="resultTemplate"
                data-uit="module-invite-modal-invite-users-input"
            />
            <ng-template #resultTemplate let-user="result" let-t="term">
                <div class="dropdown-item-wrapper align-items-center">
                    <img *ngIf="user.picture" [src]="user.picture" class="profile-img me-2" />
                    <div *ngIf="!user.picture" class="initials me-2">
                        {{ user | initials }}
                    </div>
                    <ngb-highlight [result]="user | fullNameWithEmail" [term]="t"></ngb-highlight>
                </div>
            </ng-template>
        </div>
        <div class="mt-4">
            <h4>{{ 'MODULES.DETAIL.SHARING.SHARED_WITH' | translate }}</h4>
            <p *ngIf="moduleShares.length == 0">{{ 'MODULES.DETAIL.SHARING.NOT_SHARED_YET' | translate }}</p>
            <table *ngIf="moduleShares.length > 0" class="table table-borderless shares-table table-sm">
                <tbody>
                    <tr *ngFor="let person of moduleShares" data-uit="module-invite-shares-table">
                        <td class="initials-col">
                            <img *ngIf="person.picture" [src]="person.picture" class="profile-img" />
                            <div *ngIf="!person.picture" class="initials">
                                {{ person | initials }}
                            </div>
                        </td>
                        <td>{{ person | fullName }}</td>
                        <td class="d-flex justify-content-end align-items-center">
                            <ca-switch
                                [checkedLabel]="'MODULES.DETAIL.SHARING.WRITE' | translate"
                                [uncheckedLabel]="'MODULES.DETAIL.SHARING.READ' | translate"
                                [checked]="person.role === shareUserRole.Contributor"
                                size="small"
                                (onChange)="changeAccessType(person)"
                                data-uit="module-invite-switch-sharing-rights"
                            >
                            </ca-switch>
                            <button
                                type="button"
                                class="btn ca-btn-icon"
                                (click)="removePerson(person)"
                                [ngbTooltip]="'MODULES.DETAIL.SHARING.UNSHARE_WITH' | translate: { name: person | fullName }"
                                container="body"
                                data-uit="module-detail-sharing-delete-person-button"
                            >
                                <ca-icon name="trash" size="s"></ca-icon>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <p>{{ 'MODULES.DETAIL.SHARING.SHARED_WITH_DESC_DETAIL' | translate }}</p>
            <ul class="ps-5" style="list-style-type: disc">
                <li>
                    <p>
                        {{ 'MODULES.DETAIL.SHARING.SHARED_WITH_DESC_DETAIL_READ' | translate }}
                    </p>
                </li>
                <li>
                    <p>
                        {{ 'MODULES.DETAIL.SHARING.SHARED_WITH_DESC_DETAIL_WRITE' | translate }}
                    </p>
                </li>
            </ul>
        </div>
        <div class="d-flex justify-content-end">
            <button type="submit" [disabled]="!moduleSharesHaveChanged" class="btn btn-primary" caAutoFocus data-uit="module-invite-save-btn">
                {{ 'GENERAL.SAVE' | translate }}
            </button>
        </div>
    </form>
</ca-modal-container>
